import {SavedSearchesItemModel} from "./saved-searches-item.model";

export class SavedSearchesResultModel {
    public pageNumber: number;
    public pageSize: number;
    public totalPages: number;
    public totalItems: number;

    public pageItems: Array<SavedSearchesItemModel>;
}
